// Mapping các thông báo lỗi từ backend (tiếng Anh) sang tiếng Việt.
// Dùng bởi RestApi để hiển thị toast/alert thân thiện với người chơi VN.
// Khi BE thêm error mới, bổ sung vào ERROR_MAP hoặc PREFIX_MAP bên dưới.

const ERROR_MAP: Record<string, string> = {
  // Auth
  'invalid credentials': 'Sai tài khoản hoặc mật khẩu',
  'username or email exists': 'Tên tài khoản hoặc email đã tồn tại',
  'invalid token': 'Phiên đăng nhập không hợp lệ',
  'invalid refresh': 'Token làm mới không hợp lệ',
  'missing bearer': 'Thiếu thông tin xác thực',
  'account missing': 'Tài khoản không tồn tại',
  'account banned': 'Tài khoản đã bị khoá',
  'account suspended': 'Tài khoản đang bị tạm khoá',
  'account locked': 'Tài khoản đang bị khoá',
  'no account': 'Không có tài khoản',
  'admin only': 'Chỉ dành cho quản trị viên',
  hash: 'Lỗi mã hoá mật khẩu',
  jwt: 'Lỗi tạo token',
  refresh: 'Lỗi làm mới phiên',
  redis: 'Lỗi máy chủ (cache)',
  decode: 'Lỗi giải mã dữ liệu',

  // Common server / DB
  db: 'Lỗi máy chủ',
  tx: 'Lỗi giao dịch',
  scan: 'Lỗi đọc dữ liệu',
  commit: 'Lỗi lưu dữ liệu',
  update: 'Lỗi cập nhật dữ liệu',
  insert: 'Lỗi thêm dữ liệu',
  publish: 'Lỗi gửi dữ liệu',
  audit: 'Lỗi ghi nhận giao dịch',
  destroy: 'Lỗi huỷ vật phẩm',
  equip: 'Lỗi trang bị',
  deduct: 'Lỗi trừ tiền tệ',
  'give item': 'Lỗi trao vật phẩm',
  grant: 'Lỗi cấp phát',
  item: 'Lỗi vật phẩm',
  'mark claim': 'Lỗi nhận thư',
  'reward stat': 'Lỗi cộng điểm thưởng',
  'reward diamond': 'Lỗi nhận kim cương thưởng',
  'reward item': 'Lỗi nhận vật phẩm thưởng',
  claim: 'Lỗi nhận thưởng',
  'lock item': 'Lỗi khoá vật phẩm',
  transfer: 'Lỗi chuyển vật phẩm',
  close: 'Lỗi đóng tin rao bán',
  members: 'Lỗi cập nhật thành viên',
  'char update': 'Lỗi cập nhật nhân vật',
  sp: 'Lỗi cập nhật điểm kỹ năng',
  'char lookup': 'Lỗi tra cứu nhân vật',
  'elo w': 'Lỗi cập nhật ELO (thắng)',
  'elo l': 'Lỗi cập nhật ELO (thua)',

  // Owner / validation
  'not owner': 'Bạn không có quyền với nhân vật này',
  'character not owned by account': 'Bạn không có quyền với nhân vật này',
  'invalid id': 'ID không hợp lệ',
  'invalid charId': 'ID nhân vật không hợp lệ',
  'invalid characterId': 'ID nhân vật không hợp lệ',
  'invalid guildId': 'ID bang hội không hợp lệ',
  'invalid friendId': 'ID bạn bè không hợp lệ',
  'invalid itemId': 'ID vật phẩm không hợp lệ',
  'invalid slot': 'Vị trí trang bị không hợp lệ',
  invalid: 'Dữ liệu không hợp lệ',
  channel: 'Kênh chat không hợp lệ',
  'amount required': 'Vui lòng nhập số lượng',
  'missing target': 'Thiếu mục tiêu',

  // Inventory / Equip
  'item not found': 'Không tìm thấy vật phẩm',
  'not your item': 'Đây không phải vật phẩm của bạn',
  'not equipped': 'Vật phẩm chưa được trang bị',
  'level too low': 'Cấp độ chưa đủ',
  'class cannot use this item': 'Lớp nhân vật của bạn không thể dùng trang bị này',
  'not found or bound': 'Không tìm thấy hoặc vật phẩm đã bị khoá',
  'bound item': 'Vật phẩm đã bị khoá',
  'must be in inventory': 'Vật phẩm phải nằm trong túi đồ',

  // Storage
  'must be in storage': 'Vật phẩm phải nằm trong kho',
  'storage full': 'Kho đã đầy',
  'slot occupied': 'Ô kho đã có vật phẩm',
  'invalid quantity': 'Số lượng không hợp lệ',

  // Upgrade
  insufficient: 'Không đủ nguyên liệu',
  'cannot upgrade jewel': 'Không thể cường hoá ngọc',
  'already +15': 'Vật phẩm đã đạt cường hoá tối đa (+15)',
  'rule missing': 'Không tìm thấy luật cường hoá',
  'not enough Bless': 'Không đủ Jewel of Bless',
  'not enough Soul': 'Không đủ Jewel of Soul',
  'not enough Chaos': 'Không đủ Jewel of Chaos',

  // Skill
  'skill not learned': 'Bạn chưa học kỹ năng này',
  'skill not found': 'Không tìm thấy kỹ năng',
  'no skill point': 'Không còn điểm kỹ năng',
  'class mismatch': 'Kỹ năng không phù hợp với lớp nhân vật',
  'master skill: need reset 100': 'Kỹ năng Master yêu cầu Reset 100',
  'prereq not met': 'Chưa đạt điều kiện kỹ năng tiên quyết',
  'already learned': 'Bạn đã học kỹ năng này',
  'max level': 'Đã đạt cấp tối đa',

  // Reset
  'need level 400': 'Cần đạt cấp 400 để Reset',

  // Currency
  'not enough zen': 'Không đủ Zen',
  'not enough diamond': 'Không đủ Kim Cương',
  'unknown currency': 'Loại tiền tệ không hợp lệ',

  // Shop
  'product not found': 'Không tìm thấy sản phẩm',
  'product disabled': 'Sản phẩm đang bị tắt',
  'VIP required': 'Cần tài khoản VIP',
  'product has no item template': 'Sản phẩm chưa cấu hình vật phẩm',

  // Quest
  'quest not found': 'Không tìm thấy nhiệm vụ',
  'class not allowed': 'Lớp nhân vật không thể nhận nhiệm vụ này',
  'already claimed': 'Bạn đã nhận thưởng rồi',
  'already accepted': 'Bạn đã nhận nhiệm vụ này',
  'on cooldown': 'Nhiệm vụ đang trong thời gian chờ',
  'quest not completed': 'Nhiệm vụ chưa hoàn thành',

  // Pet / Mount
  'need level 60': 'Cần đạt cấp 60',
  'mount not found': 'Không tìm thấy thú cưỡi',

  // Party
  'already in party': 'Bạn đang ở trong tổ đội khác',
  'party not found': 'Không tìm thấy tổ đội',
  'leader only': 'Chỉ trưởng nhóm mới có quyền',
  'party full': 'Tổ đội đã đầy',
  'target already in party': 'Người này đã ở trong tổ đội khác',
  'cannot kick leader': 'Không thể đuổi trưởng nhóm',
  'not member': 'Không phải thành viên',
  'target not found': 'Không tìm thấy mục tiêu',

  // Guild
  'already in guild': 'Bạn đã ở trong bang hội khác',
  'name taken': 'Tên đã được sử dụng',
  'guild full': 'Bang hội đã đầy',
  'no permission': 'Bạn không có quyền',
  'member not found or is master': 'Không tìm thấy thành viên hoặc là bang chủ',
  'master cannot leave; transfer first': 'Bang chủ phải chuyển giao trước khi rời bang',

  // Friend
  'cannot friend self': 'Không thể kết bạn với chính mình',
  'character not found': 'Không tìm thấy nhân vật',
  'already friends': 'Hai người đã là bạn bè',
  'friend list full': 'Danh sách bạn bè đã đầy',
  'request already pending': 'Lời mời đang chờ phản hồi',
  'request not found': 'Không tìm thấy lời mời',
  'not recipient': 'Bạn không phải người nhận lời mời',
  'already resolved': 'Lời mời đã được xử lý',
  'not friends': 'Hai người chưa kết bạn',

  // Trade
  'cannot trade self': 'Không thể giao dịch với chính mình',
  'already in trade': 'Bạn đang trong phiên giao dịch khác',
  'target in trade': 'Đối phương đang trong phiên giao dịch khác',
  'trade not found': 'Không tìm thấy phiên giao dịch',
  'trade not locked': 'Cần khoá phiên trước khi xác nhận',
  'trade locked': 'Phiên đã khoá, hãy bỏ khoá để chỉnh sửa',
  'trade expired': 'Phiên giao dịch đã hết hạn',
  'trade slots full': 'Số ô vật phẩm trong phiên đã đầy',
  'item already in trade': 'Vật phẩm đã ở trong phiên giao dịch',
  'item bound': 'Vật phẩm đã bị khoá, không thể giao dịch',
  'quantity exceeds stack': 'Số lượng vượt quá số có trong túi',

  // Chat
  'no guild': 'Bạn chưa ở trong bang hội',
  'no party': 'Bạn chưa ở trong tổ đội',

  // Mail
  'claim before delete': 'Hãy nhận thưởng trước khi xoá thư',

  // Auction
  'listing not found': 'Không tìm thấy tin rao bán',
  'listing closed': 'Tin rao bán đã đóng',
  'cannot buy own': 'Không thể tự mua tin rao của mình',
  'not your listing': 'Đây không phải tin rao của bạn',
  'already closed': 'Tin rao đã được đóng',

  // Character
  'max 5 characters': 'Mỗi tài khoản tối đa 5 nhân vật',
  'not enough stat points': 'Không đủ điểm tiềm năng',

  // Generic
  'not found': 'Không tìm thấy',
  'inventory full': 'Túi đồ đã đầy',
  'bad params': 'Tham số không hợp lệ',
  insufficient_balance: 'Số dư không đủ',
};

// Các tiền tố để map các thông báo có dạng "<tiền tố>: <chi tiết>"
const PREFIX_MAP: Array<{ prefix: string; build: (rest: string) => string }> = [
  { prefix: 'account ', build: (rest) => `Trạng thái tài khoản: ${rest}` },
  { prefix: 'give item: ', build: (rest) => `Lỗi trao vật phẩm: ${translateError(rest)}` },
];

// Các status code HTTP fallback khi không có message
const STATUS_MAP: Record<number, string> = {
  400: 'Yêu cầu không hợp lệ',
  401: 'Vui lòng đăng nhập lại',
  403: 'Bạn không có quyền thực hiện thao tác này',
  404: 'Không tìm thấy dữ liệu',
  409: 'Xung đột dữ liệu',
  429: 'Bạn thao tác quá nhanh, vui lòng thử lại sau',
  500: 'Máy chủ gặp lỗi, vui lòng thử lại',
  502: 'Máy chủ tạm thời không phản hồi',
  503: 'Máy chủ đang bảo trì',
  504: 'Máy chủ phản hồi quá chậm',
};

export function translateError(raw: string | undefined | null): string {
  if (!raw) return 'Đã xảy ra lỗi không xác định';
  const msg = String(raw).trim();
  if (ERROR_MAP[msg]) return ERROR_MAP[msg];
  const lower = msg.toLowerCase();
  if (ERROR_MAP[lower]) return ERROR_MAP[lower];
  for (const { prefix, build } of PREFIX_MAP) {
    if (msg.startsWith(prefix)) return build(msg.slice(prefix.length));
  }
  return msg;
}

export function translateApiError(err: unknown): string {
  if (!err) return 'Đã xảy ra lỗi không xác định';
  const e = err as { status?: number; payload?: unknown; message?: string };
  const payloadMsg =
    e.payload && typeof e.payload === 'object'
      ? (e.payload as { error?: string; message?: string }).error ||
        (e.payload as { error?: string; message?: string }).message
      : undefined;
  const raw = payloadMsg || e.message;
  if (raw) {
    const t = translateError(raw);
    if (t !== raw) return t;
  }
  if (typeof e.status === 'number' && STATUS_MAP[e.status]) return STATUS_MAP[e.status];
  return raw || 'Đã xảy ra lỗi không xác định';
}
